<template>
  <div class="app-container">
    <span class="title">订单信息</span>
    <div class="content">
      <div>订单编号：{{ orderInfo.orderNum }}</div>
      <div>订单类型：协会订单</div>
      <div>下单时间：{{ orderInfo.createdDate | formatDateTimeDefault }}</div>
      <div>
        <span v-if="completeTime" class="complete-time">完成时间：{{ completeTime | formatDateTimeDefault }}</span>
        <span v-if="cancellationTime">取消时间：{{ cancellationTime | formatDateTimeDefault }}</span>
      </div>
      <div>订单备注：{{ orderInfo.remarks }}</div>
      <div v-if="orderInfo.userType === 2">
        <div>实际总数：{{ orderInfo.actualNums }}</div>
        <div>实际总价：{{ orderInfo.actualPrice ? orderInfo.actualPrice.toFixed(2) : '' }}</div>
        <div>下单总数：{{ orderInfo.nums }}</div>
        <div>下单总价：{{ orderInfo.money !== null ? orderInfo.money.toFixed(2) : '' }}</div>
      </div>
      <div v-if="orderInfo.orderState === 3">取消原因：{{ orderInfo.cancelReason || '' }}</div>
      <div v-if="orderInfo.otherReason">其他：{{ orderInfo.otherReason }}</div>
    </div>

    <span class="title">预约信息</span>
    <div class="content">
      <div>期望上门时间：{{ orderInfo.preferredArrivalTime | formatDateTimeDefault }}</div>
      <div>
        用户电话：{{ orderInfo.userPhone }}
        <span v-if="orderInfo.userPhone">
          <img v-if="!dataVisible.userPhone" src="@/assets/eye-close.png" @click="toggleVisibility('userPhone')" />
          <img v-else src="@/assets/eye-open.png" @click="toggleVisibility('userPhone')" />
        </span>
      </div>
      <div>联系人名称：{{ orderInfo.username }}</div>
      <div>
        联系人电话：{{ orderInfo.mobilePhone }}
        <span v-if="orderInfo.mobilePhone">
          <img v-if="!dataVisible.mobilePhone" src="@/assets/eye-close.png" @click="toggleVisibility('mobilePhone')" />
          <img v-else src="@/assets/eye-open.png" @click="toggleVisibility('mobilePhone')" />
        </span>
      </div>
      <div>
        回收地址：{{ orderInfo.provinceName + orderInfo.cityName + orderInfo.districtName + orderInfo.townName + orderInfo.address }}
        <span v-if="orderInfo.address">
          <img v-if="!dataVisible.address" src="@/assets/eye-close.png" @click="toggleVisibility('address')" />
          <img v-else src="@/assets/eye-open.png" @click="toggleVisibility('address')" />
        </span>
      </div>
      <div>预约日期：{{ orderInfo.appointmentTime | formatDateTimeDefault }}</div>
    </div>

    <span class="title">商品列表</span>
    <div class="content" style="width: 800px;">
      <div>
        <el-table :data="goodLists" style="width: 100%">
          <!-- 序号 -->
          <el-table-column type="index" label="序号" width="80"></el-table-column>
          <el-table-column prop="associationRecycleCommodityVO.productCategoryName" width="200" label="品类"></el-table-column>
          <el-table-column prop="prop" label="规格">
            <template slot-scope="scope">
              <span v-for="(item, index) in scope.row.associationRecycleStandardsVOS" class="m-r-10" :key="index">
                {{ geiStandardOptionByKey(scope.row.associationRecycleCommodityVO.productCategoryCode, item.standardsKey) }}:
                {{ item.standardsValue }}
              </span>
            </template>
          </el-table-column>
        </el-table>
        估价：{{ orderInfo.estimatedPrice }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      ifSmsOrder: false, //是否是sms回传工单
      ifBusinessOrder: false, //是否是企业订单
      dialogFormVisible: false, //添加产品弹框
      loading: false,
      // 规格字段
      standardOptions: {
        101: {
          //空调
          brandName: '品牌名称',
          typeOfAcName: '空调类型',
          typeOfClimaticControlName: '冷暖类型',
          matchingNumberName: '匹数',
          usedYearsName: '已使用年数',
          functionalConditionName: '功能状况',
          appearanceConditionName: '外观情况'
        },
        102: {
          // 电视机
          typeName: '电视机的类型',
          specificationName: '电视机的规格',
          screenConditionName: '屏幕状况描述'
        },
        104: {
          //电脑
          typeName: '电脑类型',
          graphicsCardName: '显卡型号',
          memoryCapacityName: '内存容量，单位为GB',
          hardDriveName: '硬盘类型及容量',
          functionalConditionName: '功能状况'
        },
        106: {
          // 冰箱
          capacityName: '冰箱的规格（容积）',
          brandName: '冰箱品牌',
          usedYearsName: '已使用年数',
          functionalConditionName: '功能状况'
        },
        117: {
          // 洗衣机
          typeName: '洗衣机类型',
          capacityName: '洗衣机的规格（干衣量）',
          brandName: '洗衣机品牌',
          usedYearsName: '已使用年数',
          functionalConditionName: '功能状况'
        }
      },
      completeTime: '', // 完成时间
      cancellationTime: '', //取消时间
      recyclerAllocationTime: '', //回收员分配时间
      outletAllocationTime: '', //网点分配时间
      wdphone: '', // 网点电话
      wxgphone: '', // 回收员电话
      fkren: '', // 分配工程师编号
      fkrenmc: '', // 分配工程师名称
      fkwdmc: '', // 分配网点名称
      fkwdno: '', // 分配网点编号

      orderInfo: {}, //小格绿订单信息
      productImageBase64: '',
      paymentReceiptImageBase64: '',

      phone: '', //用户电话
      workOrder: {}, //工单信息
      tblRecycleWorkOrder: [], //工单信息copy，暂存用
      orderStateList: [
        {
          label: '待取件',
          value: 1
        },
        {
          label: '已取消',
          value: 3
        },
        {
          label: '已完成',
          value: 2
        }
      ], //小格绿订单状态
      goodLists: [], //商品列表
      form: {
        spmc: '',
        spid: '',
        brandName: '',
        brandNum: '',
        xlmc: '',
        xlid: '',
        xhmc: '',
        xhno: ''
      }, //新增商品信息
      typeLabel: {
        '101': '功率',
        '102': '尺寸',
        '104': '完整程度',
        '106': '容积'
      }, //规格label
      orderState: {
        '1000': '保存',
        '1010': '待分部派工',
        '1020': '待分中心派工',
        '1030': '待网点派工',
        '1040': '待审批改派',
        '1050': '待服务人员处理',
        '1060': '服务人员报完工',
        '1070': '已作废工单',
        '1080': '正常关闭'
      }, //sms工单状态

      tblSplbDalei: [], //大类列表
      tblSplbBrand: [], //品牌列表
      tblSplbXiaolei: [], //小类列表
      tblSplbJixin: [], //机型列表
      eval: {},
      partnerName: '',
      partnershipTypeStr: '',
      originData: {},
      mobilePhone: '',
      userPhone:'',
      address: '',
      dataVisible: {
        mobilePhone: false,
        address: false,
        userPhone: false
      }
    }
  },
  created() {
    this.loadDetail()
  },
  methods: {
    geiStandardOptionByKey(productCategoryCode, key) {
      console.log('productCategoryCode', productCategoryCode)
      let currentStand = this.standardOptions[productCategoryCode]
      if (currentStand) {
        return currentStand[key]
      } else {
        return ''
      }
    },
    //初始化
    loadDetail() {
      let orderNum = this.$route.query.orderNum
      this.HttpService.get(`/autoapp-default-server-recovery/api/association-recycle-order/getOneAssociationRecycleOrder?orderNum=${orderNum}`).then(res => {
        this.orderInfo = res.data.associationRecycleOrderVO
        this.originData = res.data.associationRecycleOrderVO ? { ...res.data.associationRecycleOrderVO } : {}
        this.goodLists = res.data.associationRecycleCommodityDTOS

        // 根据 sensitizationCode 拆分数据
        if (res.data.desensitizationDtoList && Array.isArray(res.data.desensitizationDtoList)) {
          const phoneMappings = {
            mobilePhone_phone: 'mobilePhone',
            address_address: 'address',
            userPhone_phone: 'userPhone'
          }

          res.data.desensitizationDtoList.forEach(item => {
            const targetProperty = phoneMappings[item.sensitizationCode]
            if (targetProperty) {
              this[targetProperty] = {
                sensitizationCode: item.sensitizationCode,
                message: item.message
              }
            }
          })
        }
      })
    },

    getSourceOrigin(data) {
      return this.HttpService.post(`/autoapp-default-server-recovery/api/deSensitization/getSource`, data).then(res => {
        if (res.statusCode === 200) {
          return res.data
        }
      })
    },
    toggleVisibility(dataType) {
      // 切换显示状态
      this.dataVisible[dataType] = !this.dataVisible[dataType]

      // 根据不同类型处理显示逻辑
      switch (dataType) {
        case 'mobilePhone':
          if (this.dataVisible.mobilePhone && this.mobilePhone.message) {
            this.getSourceOrigin(this.mobilePhone).then(res => {
              this.$set(this.orderInfo, 'mobilePhone', res)
            })
          } else if (!this.dataVisible.mobilePhone) {
            // 还原为原始脱敏数据
            this.$set(this.orderInfo, 'mobilePhone', this.originData.mobilePhone)
          }
          break
        case 'address':
          if (this.dataVisible.address && this.address.message) {
            this.getSourceOrigin(this.address).then(res => {
              this.$set(this.orderInfo, 'address', res)
            })
          } else if (!this.dataVisible.address) {
            // 还原为原始脱敏数据
            this.$set(this.orderInfo, 'address', this.originData.address)
          }
          break
        case 'userPhone':
          if (this.dataVisible.userPhone && this.userPhone.message) {
            this.getSourceOrigin(this.userPhone).then(res => {
              this.$set(this.orderInfo, 'userPhone', res)
            })
          } else if (!this.dataVisible.userPhone) {
            // 还原为原始脱敏数据
            this.$set(this.orderInfo, 'userPhone', this.originData.userPhone)
          }
      }
    }
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.title {
  font-weight: bold;
  font-size: 18px;
  margin-left: 30px;
}

.complete-time {
  margin-right: 100px;
}

.content {
  margin: 30px;

  div {
    margin-bottom: 16px;
  }
}

.button-row {
  width: 920px;
  display: flex;
  justify-content: flex-end;
}

.table {
  margin-left: 30px;
  padding-top: 10px;
}

.dialog-body {
  margin-left: 70px;
}

.dialog-footer {
  padding: 15px;
}

.btnBack {
  margin-left: 30px;
}

.row-flex {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
}
</style>



// WEBPACK FOOTER //
// src/views/order/valuationEdit.vue